<div normal>
    <modal-default-mmaxapp>
            <div class="tarjetaconfirmar">
                <div class="titulo">
                        Proveedores
                </div>
                <div class="leyendaconfirmar">
                        {{infoprov}}
                </div>
                <div class="botones">
                        <button class="buttonpc whibutton" (click)="aceptar()">Aceptar</button>
                </div>
            </div>
    </modal-default-mmaxapp>
</div>